module.exports = __webpack_public_path__ + "3f9e9248307fc7dc2ab36be32519269a.png";